export const isNotPaid = (received: any, given: any) => {
    return Number(received) > Number(given);
  };